import React from 'react';
import SoftRejectionWithCardholder from '~/pages/stageResult/salesforceSoftDecline/SoftRejectionWithCardholder';
import SoftRejectionWithoutcardholder from '~/pages/stageResult/salesforceSoftDecline/SoftRejectionWithoutcardholder';
import { useGetApplication } from '~/controllers/wizard';
import { getStagePayload } from '~/utils/getStagePayload';
function SalesforceSoftDecline() {
  const applicationQuery = useGetApplication();
  const rejectedCardholderData: any = !!getStagePayload.salesforceSoftDecline(applicationQuery.data)
    ?.cardholdersRejected?.length;

  return rejectedCardholderData ? <SoftRejectionWithCardholder /> : <SoftRejectionWithoutcardholder />;
}

export default SalesforceSoftDecline;
